import { FiltersBlock } from "./FiltersBlock";
import { NoContentBlock } from "../ui";
import { Pagination, Stack } from "@mui/material";
import { NoFeedbackBlock } from "./NoFeedbackBlock";
import { useStateWithSearchParams } from "../../hooks";
import { FeedbackItem } from "./FeedbackItem";
import { useGetFeedbacksQuery } from "api";
import { CustomLoader } from "../ui/CustomLoader";
import { Order } from "../../types";
import { useEffect } from "react";
import { QUERY_SEPARATOR } from "../../constant";

type SearchParams = {
  rating?: string;
  sort?: string;
  search?: string;
  has_files?: string;
  page?: string;
};

export const ReviewsPageBody = () => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      rating: undefined,
      sort: undefined,
      search: undefined,
      has_files: undefined,
      page: undefined,
    },
  );

  const { rating, search, has_files, page } = searchDict;
  const [sort, order] = searchDict.sort?.split("-") || [undefined, undefined];

  const { data, isLoading, isFetching } = useGetFeedbacksQuery({
    rating: rating?.split(QUERY_SEPARATOR).map(Number) || undefined,
    sort,
    order: order as Order,
    search,
    has_files: !!has_files || undefined,
    page: page ? Number(page) - 1 : undefined,
    per_page: 10,
  });

  useEffect(() => {
    setSearchValue("page", undefined);
  }, [rating, search, has_files, searchDict.sort]);

  if (!data || isLoading) return <CustomLoader />;

  const { items, total_pages, count } = data;
  const isFilters = Object.values(searchDict).some((el) => el);

  if (count === 0 && !isFilters && !isFetching) {
    return <NoFeedbackBlock />;
  }

  return (
    <Stack gap="24px" flexGrow={1}>
      <FiltersBlock />

      {items.map((feedback) => (
        <FeedbackItem key={feedback.id} item={feedback} />
      ))}

      {isFilters && items.length === 0 && (
        <NoContentBlock
          title={"No Matching Reviews"}
          text={
            "No reviews match the current filters. Try changing or clearing them to see more results."
          }
        />
      )}
      {total_pages > 1 && (
        <Stack justifyContent="center" alignItems="center" width="100%">
          <Pagination
            count={total_pages}
            page={Number(searchDict.page) || 1}
            onChange={(_, page) => setSearchValue("page", String(page))}
            showFirstButton
            showLastButton
          />
        </Stack>
      )}
    </Stack>
  );
};
